<template>
	<v-dialog
		v-model="open"
		max-width="1200"
		@click:outside="open = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">更新履歴</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="open = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2 overflow-x-auto">
				<v-sheet elevation="0" class="mt-4">
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th class="pa-2 no-wrap">項目</th>
								<th class="pa-2 no-wrap">変更日</th>
								<th class="pa-2 no-wrap">変更者</th>
								<th class="pa-2 no-wrap">変更理由</th>
								<th class="pa-2 no-wrap">サブタイトル</th>
								<th class="pa-2 no-wrap">希望納期</th>
								<th class="pa-2 no-wrap">伝達事項</th>
								<th class="pa-2 no-wrap" v-if="requirement.requirement_type.need_matter_flag">
									案件
								</th>
								<th class="pa-2 no-wrap" v-if="requirement.requirement_type.need_matter_flag">
									見積製品
								</th>
								<th class="pa-2 no-wrap" v-if="requirement.requirement_type.need_matter_flag">
									受注製品(製番)
								</th>
								<th class="pa-2 no-wrap" v-if="requirement.requirement_type.need_matter_flag">
									受注製品(枝番)
								</th>
								<th class="pa-2 no-wrap" v-for="column in requirementColumns" :key="column.id">
									{{ column.name }}
								</th>
							</tr>
							<tr>
								<td class="pa-2 no-wrap">初期値</td>
								<td class="pa-2 no-wrap">-</td>
								<td class="pa-2 no-wrap">{{ common.returnUserName(requirement.user) }}</td>
								<td class="pa-2 no-wrap">-</td>
								<td class="pa-2 no-wrap">{{ requirement.subtitle }}</td>
								<td class="pa-2 no-wrap">{{ requirement.deadline | toMoment }}</td>
								<td class="pa-2 no-wrap">{{ requirement.message }}</td>
								<td class="pa-2 no-wrap" v-if="requirement.requirement_type.need_matter_flag">
									{{ requirement.matter ? returnMatterInfo(requirement.matter) : "" }}
								</td>
								<td class="pa-2 no-wrap" v-if="requirement.requirement_type.need_matter_flag">
									{{
										requirement.matter_product.id != null
											? requirement.matter_product.name +
											  " 数量：" +
											  requirement.matter_product.quantity
											: ""
									}}
								</td>
								<td class="pa-2 no-wrap" v-if="requirement.requirement_type.need_matter_flag">
									{{
										requirement.ordered_product.id != null
											? requirement.ordered_product.name +
											  " 数量：" +
											  requirement.ordered_product.quantity +
											  " 製番:" +
											  requirement.ordered_product.product_number
											: ""
									}}
								</td>
								<td class="pa-2 no-wrap" v-if="requirement.requirement_type.need_matter_flag">
									{{
										requirement.order_individual_info.id != null
											? requirement.order_individual_info.name +
											  " 数量：" +
											  requirement.order_individual_info.quantity +
											  " 製番:" +
											  requirement.order_individual_info.product_number
											: ""
									}}
								</td>

								<td
									class="pa-2 no-wrap"
									v-for="column in requirementColumns"
									:key="'v-' + column.id"
								>
									{{ column.data_type != "file" ? requirementValueShowByColumn(column) : "" }}
								</td>
							</tr>
							<tr v-for="(log, index) in fixlogs" :key="'parent' + index">
								<td class="pa-2 no-wrap">変更{{ index + 1 }}</td>
								<td class="pa-2 no-wrap" v-for="(item, i) in log" :key="'child' + i">
									{{ i == 0 ? common.tranceMoment(item) : item }}
								</td>
							</tr>
						</tbody>
					</table>
				</v-sheet>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="8" />
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="open = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import moment from "moment"
import common from "../../../helper/common"

export default {
	components: {
		TemplateDeleteDialog,
	},
	props: {},
	data() {
		return {
			open: false,
			common: common,
			requirementId: Number,
			statusJp: Object,
			requirement: {
				matter: { name: "" },
				requirement_type: { need_matter_flag: false },
				user: { last_name: "", first_name: "" },
			},
			requirementFixes: [],
			requirementValues: [],
			requirementColumns: [],
			fixlogs: [],
		}
	},
	filters: {
		toMoment(date) {
			return moment(date).format("YYYY/MM/DD")
		},
	},
	methods: {
		requirementValueShowByColumn(column) {
			if (this.requirementValues.length > 0) {
				let target = this.requirementValues.find((value) => {
					return value.requirement_column_id == column.id
				})
				if (column.data_type == "boolean") {
					return this.returnMaruBatsu(target["value_" + column.data_type])
				} else if (column.data_type == "date") {
					return moment(target["value_" + column.data_type]).format("YYYY/MM/DD")
				} else if (column.data_type == "target") {
					return target.target_data?.name
				} else {
					return target["value_" + column.data_type]
				}
			} else {
				return "異常データ"
			}
		},
		openDialog(id) {
			this.requirementId = id
			this.open = true
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/requirements/" + this.requirementId + ".json", {
					headers,
				})
				.then((response) => {
					this.requirement = response.data.requirement
					this.requirementValues = response.data.requirement_values
					this.requirementColumns = response.data.columns
					this.requirementFixes = response.data.requirement_fixes
					this.createFixlogs()
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		createFixlogs() {
			// requirementFixを成型
			this.fixlogs = []
			this.requirementFixes.forEach((fix) => {
				let arry = []
				arry.push(fix.created_at)
				console.log(fix)
				arry.push(this.common.returnUserName(fix.user))
				arry.push(fix.reason)
				arry.push(fix.subtitle)
				arry.push(fix.deadline ? fix.deadline : "")
				arry.push(fix.message ? fix.message : "")
				if (this.requirement.requirement_type.need_matter_flag) {
					arry.push(fix.matter ? this.returnMatterInfo(fix.matter) : "")
				}
				if (this.requirement.requirement_type.need_matter_flag) {
					arry.push(
						fix.matter_product.id != null
							? fix.matter_product.name + " 数量：" + fix.matter_product.quantity
							: ""
					)
				}
				if (this.requirement.requirement_type.need_matter_flag) {
					arry.push(
						fix.ordered_product.id != null
							? fix.ordered_product.name +
									" 数量：" +
									fix.ordered_product.quantity +
									" 製番:" +
									fix.ordered_product.product_number
							: ""
					)
				}
				if (this.requirement.requirement_type.need_matter_flag) {
					arry.push(
						fix.order_individual_info.id != null
							? fix.order_individual_info.name +
									" 数量：" +
									fix.order_individual_info.quantity +
									" 製番:" +
									fix.order_individual_info.product_number
							: ""
					)
				}
				this.requirementColumns.forEach((column) => {
					arry.push("")
				})
				this.fixlogs.push(arry)
			})
			this.requirementValues.forEach((value) => {
				if (value.requirement_value_fixes) {
					let sorted = common.sortCreatedAt(value.requirement_value_fixes)
					sorted.forEach((fix) => {
						let arry = []
						arry.push(fix.created_at)
						arry.push(this.common.returnUserName(fix.user))
						arry.push(fix.reason)
						arry.push("")
						arry.push("")
						arry.push("")
						if (this.requirement.requirement_type.need_matter_flag) {
							arry.push("")
							arry.push("")
							arry.push("")
							arry.push("")
						}
						this.requirementColumns.forEach((column) => {
							if (column.id == value.requirement_column.id) {
								if (column.data_type == 'target'){
									let fixedValue = fix.target_data?.name
									arry.push(common.returnValue(fixedValue, column.data_type))
								} else{
									arry.push(common.returnValue(fix["value_" + column.data_type], column.data_type))
								}
							} else {
								arry.push("")
							}
						})
						this.fixlogs.push(arry)
					})
				}
			})
			this.fixlogs = this.fixlogs.slice().sort(function (a, b) {
				return moment(b[0]).isAfter(moment(a[0])) ? -1 : 1
			})
			return this.fixlogs
		},
		returnMatterInfo(matter) {
			return (
				matter.name +
				"\n見積番号：" +
				matter.quotation_number +
				"-" +
				matter.quotation_sub_number +
				"\n受注番号："
			)
		},
		valueValue(value) {
			let data = ""
			if (value.value_text) {
				data = value.value_text
			} else if (value.value_date) {
				data = value.value_date
			} else if (value.value_boolean || value.value_boolean == false) {
				data = this.returnMaruBatsu(value.value_boolean)
			} else if (value.value_integer) {
				data = value.value_integer
			} else if (value.value_float) {
				data = value.value_float
			} else if (value.value_url) {
				data = value.value_url
			} else if (value.value_feature) {
				data = value.value_feature
			}
			return data
		},
		returnMaruBatsu(bool) {
			if (bool == "true") {
				return "○"
			} else if (bool == "false") {
				return "×"
			} else if (bool == true) {
				return "○"
			} else if (bool == false) {
				return "×"
			}
		},
	},
	computed: {},
	watch: {},
}
</script>
